import { types } from 'mobx-state-tree';

import Media from '../Media';

const StudentLessonGrade = types
	.model('StudentLessonGrade', {
		chunk_id: types.maybe(types.maybeNull(types.number)),
		comment: types.maybeNull(types.string),
		created_at: types.maybeNull(types.string),
		teacher_id: types.maybeNull(types.number),
		teacher_first_name: types.optional(types.maybeNull(types.string), ''),
		teacher_last_name: types.optional(types.maybeNull(types.string), ''),
		miro_link: types.maybeNull(types.string),
		teacher_zoom_access_code: types.maybeNull(types.string),
		teacher_zoom_id: types.maybeNull(types.string),
		teacher_zoom_link: types.maybeNull(types.string),
		zoom_access_code: types.maybeNull(types.string),
		zoom_id: types.maybeNull(types.string),
		zoom_link: types.maybeNull(types.string),
		student_url: types.optional(types.array(types.string), []),
		student_file: types.optional(types.array(Media), []),
		reject_comment: types.maybeNull(types.string),
		rejected_at: types.maybeNull(types.string),
		dictaphone_url: types.optional(types.array(types.string), []),
		dictaphone_file: types.optional(types.array(Media), []),
		annotate_url: types.optional(types.array(types.string), []),
		annotate_file: types.optional(types.array(Media), []),
	})
	.views((self) => ({
		get fullName() {
			const { teacher_first_name: first, teacher_last_name: last } = self;
			if (first && last) return `${first} ${last}`;

			return first || last || null;
		},
	}));

export default StudentLessonGrade;
